import type { IObjectiveTypeBase } from './ObjectiveTypeBase.interface';
import ObjectiveTypeBaseReason from './ObjectiveTypeBaseReason';
import { ImportantOption } from '../global/ImportantOption.enum';
import { YesNoOption } from '../global/YesNoOption.enum';
import { ObjectivePreferredDurationOption } from './ObjectivePreferredDurationOption.enum';
import { PaymentFrequency } from '../global/PaymentFrequency.enum';
import { ObjectivePaymentPlanOption } from './ObjectivePaymentPlanOption.enum';

export default class ObjectiveTypeBase implements IObjectiveTypeBase {
  type: ImportantOption;
  isConfirmed: YesNoOption;
  preferredDuration: ObjectivePreferredDurationOption;
  preferredPaymentFrequency: PaymentFrequency;
  planForPayingLineOfCredit: ObjectivePaymentPlanOption;
  reason: ObjectiveTypeBaseReason;

  static build = (data: IObjectiveTypeBase) => new ObjectiveTypeBase(data);

  static blank = () => new ObjectiveTypeBase();

  /**
   * Constructor
   * @param {IObjectiveTypeBase} data
   */
  constructor(data?: IObjectiveTypeBase, type) {
    this.type = ImportantOption.of(data?.type?.name || `r${data?.type}`);
    this.isConfirmed = YesNoOption.of(data?.isConfirmed?.name || data?.isConfirmed?.toString());
    this.preferredDuration =
      type === 'interestOnly'
        ? ObjectivePreferredDurationOption.of(
            data?.preferredDuration?.name || `i${data?.preferredDuration}`
          )
        : ObjectivePreferredDurationOption.of(
            data?.preferredDuration?.name || data?.preferredDuration?.toString()
          );
    this.preferredPaymentFrequency = PaymentFrequency.of(
      data?.preferredPaymentFrequency?.name || `o${data?.preferredPaymentFrequency}`
    );
    this.planForPayingLineOfCredit = ObjectivePaymentPlanOption.of(
      data?.planForPayingLineOfCredit?.name || data?.planForPayingLineOfCredit?.toString()
    );
    this.reason = new ObjectiveTypeBaseReason(data?.reason);
  }
}
